import { css, createGlobalStyle } from "styled-components";
import { makeStylesSeeded } from "@origin-digital/ods-core";

const fontList = [
  ["regular", 500],
  ["medium", 600],
  ["bold", 700],
];

function getTalPublicAssetsPath() {
  return typeof exports === "undefined"
    ? window["oetal"].env.talPublicAssetsPath
    : `${process.env["TAL_PUBLIC_ASSETS_ORIGIN"]}/static/tal-client/`;
}

const GorditaFontStyles = () => {
  return fontList.map(([style, weight]) => {
    const fontPrefix = `gordita${style}`;
    const fontName = `${fontPrefix}-webfont`;
    return css`
      @font-face {
        font-family: "gordita";
        src: url("${getTalPublicAssetsPath()}fonts/gordita/${fontName}.woff2")
            format("woff2"),
          url("${getTalPublicAssetsPath()}fonts/gordita/${fontName}.woff")
            format("woff");
        font-weight: ${weight};
        font-style: ${style};
      }
    `;
  });
};

export const FontStyles = createGlobalStyle`
  ${GorditaFontStyles()}

  @font-face {
    font-family: "originicons";
    src: url('${getTalPublicAssetsPath()}fonts/originicons/originicons.woff') format('woff');
    font-weight: 400;
    font-style: normal;
  }
`;

export const ResetStyles = createGlobalStyle`
  * {
    font-family: 'gordita', Arial, sans-serif;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }
  html, body, #root {
    height: 100%;
  }
  body {
    margin: 0;
    padding: 0;
  }
  body, h1, h2, h3, p, span {
    font-weight: normal;
  }
  #root {
    display: flex;
    flex-direction: column;
  }
`;

export const IconFontStyles = createGlobalStyle`
  @font-face{
    font-family: "Material Icons";
    src:
        url('${getTalPublicAssetsPath()}fonts/materialIcons/MaterialIcons-Regular.woff2') format('woff2'),
        url('${getTalPublicAssetsPath()}fonts/materialIcons/MaterialIcons-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
  }

  .md-icon {
    font-family: 'Material Icons', Arial, sans-serif;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    /* Preferred icon size */
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;

    vertical-align: bottom;
    margin-right: 5px;

    direction: ltr;
    /* Support for all WebKit browsers. */
    -webkit-font-smoothing: antialiased;
    /* Support for Safari and Chrome. */
    text-rendering: optimizeLegibility;
    /* Support for Firefox. */
    -moz-osx-font-smoothing: grayscale;
    /* Support for IE. */
    font-feature-settings: 'liga';
  }
`;

/*
 * Braze styling:
 * ensure Modals include Gordita font,
 * round and style buttons.
 */
export const BrazeStyles = createGlobalStyle`
  #braze-oe .ab-message-header,
  #braze-oe .ab-message-text {
    font-family: gordita, Arial, sans-serif;
  }
  #braze-oe .ab-message-header { font-weight: 600; font-size: 18px; }
  @media (min-width: 992px) {
    #braze-oe .ab-message-header { font-size: 20px; }
  }
  #braze-oe .ab-message-text.ab-with-buttons { margin-bottom: 104px; }
  #braze-oe .ab-message-buttons { padding: 24px 24px 32px; }
  #braze-oe .ab-message-button {
    padding: 12px 24px; border-radius: 24px;
    font: 600 16px/24px gordita, Arial, sans-serif;
    height: auto;
  }
  @media (max-width: 600px) {
    #braze-oe .ab-in-app-message.ab-slideup {
      max-width: 90%; max-width: calc(100% - 52px);
      min-width: 90%; min-width: calc(100% - 52px);
      margin: 16px;
    }
  }
`;

export const IdentityConsoleStyles = makeStylesSeeded(
  () => ({
    bannerStyle: {
      backgroundColor: "#1e0d35",
      borderRadius: "0",
      paddingTop: "4px",
      paddingBottom: "4px",
    },
  }),
  { classNamePrefix: "Identity" }
);
